import DateFnsUtils from "@date-io/date-fns";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import "date-fns";
import MaterialTable from "material-table";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
// eslint-disable-next-line
import { getSuppliers } from "../../Ancillary/SupplierManagement/helper/supplierManagementHelper";
import { getSessionData } from "../../base/helper/baseHelper";
import Base from "../../base/views/base";
import SelectableSearch from "../../base/views/SelectableSearch";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";
import {
  getInventoryReport,
  getInventoryReportByTote,
} from "../helper/reportHelper";
import history from "../../../../history";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
      widht: "100%",
    },
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
  },
}));

function RecentCaptureGoodsReport(props) {
  const classes = useStyles();

  const [userId, setUserId] = useState("");
  const [storeId, setStoreId] = useState("");
  const [showBack, setShowBack] = useState(false);
  const [fromDate, setFromDate] = React.useState(new Date());
  const [toDate, setToDate] = React.useState(new Date());
  const [tote, setTote] = useState(null);
  const [gridData, setGridData] = React.useState([]);
  const [supplierData, setSupplierData] = React.useState({
    load: false,
    values: [],
  });
  const [reportState, setReportState] = React.useState({
    user_id: userId,
    store_id: storeId,
    from_date: "",
    to_date: "",
    selectedSupplier: { id: 0, optionname: "" },
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const startDate = queryParams.get("f_date");
    const endDate = queryParams.get("t_date");
    const supplierId = queryParams.get("supplierId");
    const supplier = queryParams.get("supplier");
    const showBackBtn = queryParams.get("showBack");
    const toteNo = queryParams.get("tote");
    if (showBackBtn === "true") setShowBack(true);
    if (startDate) setFromDate(startDate);
    if (endDate) setToDate(endDate);
    if (toteNo) setTote(toteNo);
    if (supplierId || supplier) {
      setReportState((prev) => {
        const supplierObj = { ...prev.selectedSupplier };
        supplierObj.id = supplierId || supplierObj.id;
        supplierObj.optionname = supplier || supplierObj.optionname;
        return { ...prev, selectedSupplier: supplierObj };
      });
    }
  }, []);
  // eslint-disable-next-line
  const getLastWeek = () => {
    var today = new Date();
    var lastWeek =
      today.getFullYear() +
      "/" +
      (today.getMonth() + 1) +
      "/" +
      (today.getDate() - 7);
    return new Date(lastWeek);
  };

  // eslint-disable-next-line
  const getNextWeek = () => {
    var today = new Date();
    today.setDate(today.getDate() + 7);
    var nextWeek =
      today.getFullYear() +
      "/" +
      (today.getMonth() + 1) +
      "/" +
      today.getDate();
    return new Date(nextWeek);
  };

  useEffect(() => {
    setUserId(getSessionData({ key: "userId" }));
    const store = JSON.parse(getSessionData({ key: "store" }));
    setStoreId(store.storeid);
    // eslint-disable-next-line
  }, [userId, storeId]);

  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const loadReport = (e) => {
    var fDate = new Date(fromDate);
    var strFromDate =
      fDate.getFullYear() +
      "/" +
      (fDate.getMonth() + 1) +
      "/" +
      fDate.getDate();

    var tDate = new Date(toDate);
    var strToDate =
      tDate.getFullYear() +
      "/" +
      (tDate.getMonth() + 1) +
      "/" +
      tDate.getDate();

    var strSupplier =
      reportState.selectedSupplier.optionname !== undefined
        ? reportState.selectedSupplier.optionname
        : "";

    if (tote) {
      getInventoryReportByTote(
        userId,
        storeId,
        strFromDate,
        strToDate,
        strSupplier,
        tote
      )
        .then((response) => {
          if (response && response.length > 0) {
            setGridData(response);
          } else {
            setGridData([]);
          }
        })
        .catch((err) => {});
    } else {
      getInventoryReport(userId, storeId, strFromDate, strToDate, strSupplier)
        .then((response) => {
          if (response && response.length > 0) {
            setGridData(response);
          } else {
            setGridData([]);
          }
        })
        .catch((err) => {});
    }
  };

  const loadSupplierDropdown = () => {
    setSupplierData({ ...supplierData, load: true });
    getSuppliers(storeId)
      .then((response) => {
        let dropdownData = [];
        if (response.data.length)
          dropdownData = response.data.map((obj) => ({
            id: obj.supplier_id,
            optionname: obj.name,
          }));
        setSupplierData({ load: false, values: dropdownData });
      })
      .catch((err) => {});
  };

  const handleSupplierChange = (event, value) => {
    if (value && value.id) {
      setReportState({
        ...reportState,
        selectedSupplier: { id: value.id, optionname: value.optionname },
      });
    } else {
      setReportState({
        ...reportState,
        selectedSupplier: {},
      });
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <Base showBaseMenu={true} title="Goods Receivable (GR) Report">
        <CssBaseline />
        {showBack && (
          <Grid
            container
            spacing={3}
            style={{ marginLeft: "1%", marginTop: "1.5%" }}
          >
            <Grid item xs={12}>
              <Button
                onClick={() => history.goBack()}
                color="primary"
                variant="contained"
                size="medium"
                style={{
                  marginTop: "3%",
                  backgroundColor: "rgb(22, 177, 255)",
                  borderRadius: "0.5rem",
                }}
              >
                {"<-"} Back
              </Button>
            </Grid>
          </Grid>
        )}
        <Grid
          container
          spacing={3}
          style={{ marginLeft: "1%", marginTop: "1.5%" }}
        >
          <Grid item xs={12} sm={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid justify="space-between">
                <KeyboardDatePicker
                  autoFocus
                  autoOk={true}
                  okLabel={""}
                  cancelLabel={""}
                  margin="normal"
                  id="fromDate"
                  label="From Date"
                  format="MM/dd/yyyy"
                  value={fromDate}
                  onChange={handleFromDateChange}
                  className={classes.submit}
                  fullWidth
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} sm={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid justify="space-around">
                <KeyboardDatePicker
                  margin="normal"
                  id="toDate"
                  label="To Date"
                  format="MM/dd/yyyy"
                  autoOk={true}
                  okLabel={""}
                  cancelLabel={""}
                  value={toDate}
                  onChange={handleToDateChange}
                  className={classes.submit}
                  fullWidth
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div style={{ paddingTop: 25 }}>
              <SelectableSearch
                value={reportState.selectedSupplier}
                data={supplierData}
                name="supplier"
                label="Supplier"
                id="supplier"
                loading={loadSupplierDropdown}
                onChangeEvent={handleSupplierChange}
                variantType="standard"
              ></SelectableSearch>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Button
              onClick={(e) => {
                loadReport(e);
              }}
              fullWidth={true}
              color="primary"
              variant="contained"
              size="medium"
              style={{
                marginTop: "10%",
                backgroundColor: "rgb(22, 177, 255)",
                borderRadius: "0.5rem",
              }}
            >
              Generate
            </Button>
          </Grid>
        </Grid>
        <div className={classes.root}>
          <MaterialTable
            title=""
            columns={[
              {
                title: "Invoice date",
                field: "loaddate",
                cellStyle: {
                  width: "12%",
                },
                type: "date",
                render: (row) =>
                  new Date(row.loaddate).toLocaleDateString("en-US"),
              },
              { title: "Supplier", field: "supplier" },
              { title: "Lot No", field: "lot" },
              {
                title: "NDC",
                field: "ndc",
                cellStyle: {
                  width: "12%",
                },
              },
              {
                title: "Description",
                field: "description",
                defaultSort: "asc",
                cellStyle: {
                  width: "33%",
                },
              },
              { title: "Quantity", field: "quantity" },
              {
                title: "Expiry Date",
                field: "expirationdate",
                type: "date",
                render: (row) =>
                  new Date(row.expirationdate).toLocaleDateString("en-US"),
              },
            ]}
            data={gridData}
            options={{
              maxBodyHeight: 670,
              paging: true,
              pageSize: 25,
              pageSizeOptions: [25, 50, 100],
              headerStyle: {
                backgroundColor: "rgba(255,255,255,1)",
                color: "black",
              },
              exportButton: true,
              exportAllData: true,
            }}
          />
        </div>
        <LandingPageFooter />
      </Base>
    </div>
  );
}

const mapStateToDispatch = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToDispatch,
  mapDispatchToProps
)(RecentCaptureGoodsReport);
